
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { LocationProvider } from './contexts/LocationContext'
import App from './App.tsx'
import './index.css'

// Add performance monitoring
const reportWebVitals = () => {
  if (window.performance) {
    const timing = window.performance.timing;
    
    window.addEventListener('load', () => {
      setTimeout(() => {
        const pageLoadTime = timing.loadEventEnd - timing.navigationStart;
        const domLoadTime = timing.domComplete - timing.domLoading;
        
        console.log(`Page Load Performance:
          - Total Load Time: ${pageLoadTime}ms
          - DOM Load Time: ${domLoadTime}ms
          - Server Response Time: ${timing.responseEnd - timing.requestStart}ms
          - DOM Interactive: ${timing.domInteractive - timing.navigationStart}ms
        `);
      }, 0);
    });
  }
};

// Ensure coming soon banner is permanently disabled
try {
  // Set local storage flags to ensure banner is dismissed
  localStorage.setItem("instamg-coming-soon-dismissed", "true");
  localStorage.setItem("instamg-password-verified", "true");
} catch (error) {
  console.error("Error setting coming soon dismissed status:", error);
}

// Create root and render app
const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

// Preconnect to important domains
const preconnectLinks = [
  { rel: 'preconnect', href: 'https://kyyihbioaxmkvhqgewxq.supabase.co' },
  { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
  { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: '' },
];

// Add preconnect links
preconnectLinks.forEach(link => {
  const linkEl = document.createElement('link');
  linkEl.rel = link.rel;
  linkEl.href = link.href;
  if (link.crossOrigin) linkEl.crossOrigin = link.crossOrigin;
  document.head.appendChild(linkEl);
});

createRoot(rootElement).render(
  <BrowserRouter>
    <AuthProvider>
      <LocationProvider>
        <App />
      </LocationProvider>
    </AuthProvider>
  </BrowserRouter>
);

// Monitor performance
reportWebVitals();
